import { useAppDispatch, useAppSelector } from 'lib/hooks';
import { useEffect, useRef, useState } from 'react';
import { addToCart } from 'slices/cartSlice';
import { setRecommendedType } from 'slices/recommendationSlice';
import {
  plansToCartForType,
  selectRecommendationPlansByYear,
} from 'slices/selectors';

export const useCart = () => {
  const [type, setType] = useState<string>('');

  const dispatch = useAppDispatch();
  const plansByYear = useAppSelector(selectRecommendationPlansByYear);
  const plansByYearRef = useRef(plansByYear);

  useEffect(() => {
    plansByYearRef.current = plansByYear;
  }, [plansByYear]);

  // Fill the cart only when the chosen type changes. AppInitializer keeps
  // this hook mounted, and a later browse or refresh rewrites the buckets.
  // addToCart only skips exact matches, so re-applying would leave the
  // previous first-choice plans in the cart.
  useEffect(() => {
    if (type !== 'mapd' && type !== 'gap_pdp') {
      return;
    }

    dispatch(setRecommendedType(type));
    for (const plan of plansToCartForType(plansByYearRef.current, type)) {
      dispatch(addToCart(plan));
    }
  }, [dispatch, type]);

  return (type: string) => {
    setType(type);
  };
};
